// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"5502e480","522":"5502e480","841":"3ab8b6a3","939":"5502e480","1766":"5502e480","2445":"5502e480","4623":"5502e480","4651":"5502e480","4667":"5502e480","7767":"5502e480","8666":"5502e480"}[chunkId] + ".chunk.css";
};